<template>
  <div>    
      <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="false"            
        :preview-modal="false"
        :paginate-elements-by-height="1122"
        filename="Transfer Steckbrief"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="portrait"
        pdf-content-width="796px"
        @beforeDownload="beforeDownload($event)"                                
        ref="html2Pdf_inner"        
        >
        <section slot="pdf-content" class="pagewrap">

          <section class="pdfsection top2">
            <div 
              class="backgroundtop" 
              :style="{'background-size': 'cover', 'background-position': 'center', 'background-image': 'linear-gradient(0deg, rgba(9, 93, 169, 0.74), rgba(9, 93, 169, 0.74)), url(' + pass.pathimg + ')', 'height': '150px', 'overflow': 'hidden'}">
              <!--
              <img src="@/images/header_ff/material.jpg" height="150" />
              -->
              <!--<FBimage :areaid="pass.area" :path="pass.pathimg"></FBimage>-->
            </div>
            <div class="logo2">
              <img src="@/images/logo_thwi_w.png" height="70" />
            </div>
            <div class="title2">
              <h2>TRANSFERPASS</h2>
              <h1>{{ pass.title }}</h1>
            </div>
          </section>

          <section class="pdfsection main2">
            <div class="sideleft">
              <FBtitle :areaid="pass.area" :areaname="pass.ar_name"></FBtitle>
            </div>
            <div class="sideright">
              <h5>Technische Hochschule Wildau - www.transferpass.de</h5>
            </div>
            <div class="content">
              <div
                v-for="(pa, key) in pass.elements"
                  :key="key"                                                                                             
                  >
                  <div v-if="pa.contentpdf" style="padding-bottom: 8px;">
                  <h4 v-if="pa.name">{{ pa.name }}</h4>
                  <h4 v-else>{{ pa.elemname }}</h4>
                  <div class="paragraph" v-html="pa.contentpdf"></div>
                  </div>
              </div>
            </div>
          </section>

          <section class="pdfsection footer">
            <div class="qrcode">
              <qrcode-vue v-if="qrvalue" render-as="svg" class="printqrcode" :value="qrvalue" :size="qrsize" level="H"></qrcode-vue>
              <!--
              <img src="@/images/transferpass-qr.png" />
              -->
            </div>        
            <div class="icon">
              <img :src="getIconUrl(pass.ar_icon)" width="84px" height="84px" v-if="pass.ar_icon" style=""/>
            </div>        
            <div class="col1">  
              <b>Fachkontakt</b><br>        
              {{ responsible.fullname }}<br>
              {{ responsible.telephone }}<br>
              {{ responsible.email }}              
            </div>
          </section>

        </section>

      </vue-html2pdf>
  </div>
</template>

<script>

  //import jspdf from 'jspdf';
  import VueHtml2pdf from 'vue-html2pdf';
  // import FBimage from './elements/FBimage';
  import FBtitle from './elements/FBtitle';
  import QrcodeVue from 'qrcode.vue';

  export default {
    name: 'PDF_pass',
    props: [],
    components: {
        VueHtml2pdf,
        // FBimage,
        FBtitle,
        QrcodeVue
    },
    data: () => ({    
        pdfcontent: {},
        pass: {},
        responsible: {},
        qrvalue: null,
        qrsize: 90
    }),
    methods: {
      cover(url) {
          if (url !== ''){ // You can check any matching expression.
              try {
                  url = require('@/logo/' + url)
              } catch (e) {
                  url = require('@/logo/default.jpg'); // I used a default image. 
              }
          }
          else
              url = require('@/logo/default.jpg'); // Default image. 
          return url;
      },
      modifyIconName(inputString, charToAdd) {
          let parts = inputString.split(".");
          parts[0] = parts[0] + charToAdd;
          let modifiedString = parts.join(".");
          return modifiedString;
      },
      getIconUrl(iconName) {
        let url = null;
        let name = this.modifyIconName(iconName, 'd');
        // url = '@/images/circle_default_w_blue.png';
        url = require('@/images/svg/' + name);
        return url;
      },
      generateQRCode (pass) {
        console.log('generateQRCode');
        console.log(this.$config.web + "/" + pass.alias);
        this.qrvalue = this.$config.web + "/" + pass.alias;
      },
      generatePdfProfile (pass, responsible) {
        this.generateQRCode(pass);
        // console.log('generatePdfProfile');
        this.pdfcontent = pass;
        //this.pdfcontent.contact = this.convertLineBreak(content.contact),
        this.pass = pass;
        this.responsible = responsible;
        this.$refs.html2Pdf_inner.generatePdf();
      },
      async beforeDownload ({ html2pdf, options, pdfContent }) {

        const self = this;

        function deUmlaut(value){
          value = value.toLowerCase();
          value = value.replace(/ä/g, 'ae');
          value = value.replace(/ö/g, 'oe');
          value = value.replace(/ü/g, 'ue');
          value = value.replace(/ß/g, 'ss');
          // value = value.replace(/ /g, '-');
          value = value.replace(/\./g, '');
          value = value.replace(/,/g, '');
          value = value.replace(/\(/g, '');
          value = value.replace(/\)/g, '');
          return value;
        }

        let pdfTitle = this.pass.title.toLowerCase();
        pdfTitle = deUmlaut(pdfTitle);

        //eslint-disable-next-line
        pdfTitle = pdfTitle.replace(/(?!\w|\s)./g, '').replace(/\s+/g, '_').replace(/\//g, "");

        await html2pdf()
          .from(pdfContent)
          .set(options)
          .toPdf()
          .outputPdf('blob')
          .then(function(pdf) {
            const file = new File(
              [pdf],
              pdfTitle + '.pdf',
              {type: 'application/pdf'}
            ); 
            const formData = new FormData();        
            const config = { 
              headers: { 'Content-Type': 'multipart/form-data' } 
            };

            formData.append("pdffile", file);

            // console.log('backend host:');
            // console.log(self.$config.host);

            self.axios.post(self.$config.host + '/pdfupload', formData, config)
            .then(response => {              
              if(response.data && response.data.file) {
                window.open(self.$config.web + response.data.path + response.data.file, '_blank');
              }
            })
            .catch(error => {
              console.error('Error:', error);
            });
          })
      }      
    },
    computed: {      

    }

  }
</script>

<style>

/* 2024 */

.pagewrap {
  height:1110px;
  position: relative;    
  padding:12px 12px 0;
}
.pdfsection {
  margin:0px;
  padding:0 24px;
  /* font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;*/
  font-family: Arial, Helvetica, sans-serif;
}
.pdfsection.top2 {
  height: 150px;
  margin:0;
  position:relative;
}
.backgroundtop {
  position: absolute;
  top:0;
  left:0;
  width:100%;
  height: 150px; 
  z-index:-1;
}
.backgroundtop > img {
  width:100%;
  height: 150px;
  object-fit: cover;
  margin-top:-40%;
}
.pdfsection.main2 {
  height:809px;
  margin:0;
  padding:20px 0 0;
  position:relative;  
}
.pdfsection.footer {
  height: 150px;
  font-size:.74rem;
  border:0px solid red;
}
.pdfsection.top2 .logo2 {
  float:right;
  margin:40px 20px 0 0;
}
.pdfsection.top2 .title2 {
  padding: 50px 2px;
  margin-right:190px;
}
.pdfsection.top2 h1 {
  font-family: 'ITCStoneSemi';
  font-size: 1.5rem;
  line-height: 1.2;
  margin:0;
  padding:0;
  width: 560px;
  color: #ffffff;
}
.pdfsection.top2 h2 {
  font-family: 'ITCStoneMedium';
  font-size: .9rem;
  line-height: 1;
  margin:0;
  padding:0;
  white-space: nowrap;
  width: 560px;
  color: #ffffff;
}
.pdfsection.main2 .sideleft {
  float:left;
  width: 100px;
  height: 760px;
  position: relative;
}
.pdfsection.main2 .sideleft > h4 {
  font-family: 'ITCStoneSemi';
  position:absolute;
  transform-origin: top left;
  left:30px;
  bottom:0;
  transform: rotate(-90deg);
  width: 700px;
  text-align: center;
  height:60px;
  line-height: 2rem;
  font-size:1.7rem;
  margin:0;
  padding:0;
  color:#043180;
}
.pdfsection.main2 .sideright {
  float:right;
  width: 100px;
  height: 760px;
  text-align: center;
  position: relative;
}
.pdfsection.main2 .sideright > h5 {
  font-family: 'ITCStoneMedium';
  position:absolute;
  transform-origin: top left;
  left:30px;
  bottom:0;
  transform: rotate(-90deg);
  width: 700px;
  text-align: center;
  height:60px;
  line-height: 2rem;
  font-size:.74rem;
  margin:0;
  padding:0;
  color: #043180;
}
.pdfsection.main2 .content {
  /* insgesamt: 796px */
  float:right;
  width: 560px;
}
.pdfsection.main2 li::marker {
  color: #043180;
}
.pdfsection.main2 h4 {
  font-size: .92rem;
  line-height:1.1rem;
  font-weight: bold;
  margin:10px 0 10px 0;
  padding:0;
}
.pdfsection.main2 .paragraph {
  font-size: .92rem;
  line-height:1.1rem;
  padding-left: 20px;
  max-width: 600px;
}
.pdfsection.footer {
  position:relative;
}
.pdfsection.footer .icon {
  float:left;
  width:12%;
  padding-top: 20px;
  text-align: center;
}
.pdfsection.footer .icon img {
  max-width: 100%;
}
.pdfsection.footer .col1 {
  float:left;
  width:36%;
  padding-top:24px;
  padding-left: 30px;
}
.pdfsection.footer .col2 {
  float:left;
  width:36%;
  padding-top:60px;
}

/* QR Code */
.pdfsection.footer .qrcode {
  position: absolute;
  width:100px;
  right: 30px;
  top: 20px;
  text-align: center;
}
/*.pdfsection.footer .qrcode svg {*/
.qrcode svg {
  border:0px solid blue;
  /*
  width: 110px!important;
  height: 110px !important;
  */
}

/* Editor */
.divblock {
  display: inline-block;
}
.ql-editor ol > li, .ql-editor ul > li {
  display: block;
}

</style>